import { RootStateTypes } from './types';

const state: RootStateTypes = {
    routeName: "index",
    accountDialogType: 'login', //login setPasswd register
    showAccountDialog: false,
    userInfo: { }
       
};

export default state;
